import { createFileRoute, redirect } from '@tanstack/react-router';
import type { AuthContextType } from '@/features/auth';
import * as authLib from '@/lib/auth';
import { getQuoteDetailPathForRoles } from '@/lib/quote-deep-link';

function QuoteEntryShell() {
  return null;
}

export const Route = createFileRoute('/quotes/$quoteId')({
  component: QuoteEntryShell,
  beforeLoad: ({ context, params, location }) => {
    const auth = (context as { auth: AuthContextType }).auth;
    const storedUser = authLib.getStoredUser();
    const isAuthenticated = Boolean(auth?.isAuthenticated || authLib.isAuthenticated());

    if (!isAuthenticated) {
      if (typeof sessionStorage !== 'undefined') {
        sessionStorage.setItem('returnUrl', location.href);
      }
      throw redirect({ to: '/login', replace: true });
    }

    const roles = auth?.user?.roles || storedUser?.roles || [];
    const target = getQuoteDetailPathForRoles(params.quoteId, roles);

    if (!target) {
      throw redirect({ to: '/unauthorized', replace: true });
    }

    throw redirect({ to: target, replace: true });
  },
});
